export default "__VITE_ASSET__8f78f698__"